export const DEBIT = 'debit';
export const CREDIT = 'credit';
export const VALIDE = 'Valide';
export const ENREGISTRE = 'Enregistre';

export const SENS_DEBIT_CREDIT = [
  { libelle: 'addOperationDiverse.debit', code: DEBIT },
  { libelle: 'addOperationDiverse.credit', code: CREDIT },
];

export const LISTE_ETAT_OD = [
  { libelle: 'listeOperationDiverse.etat.enregistre', value: ENREGISTRE },
  { libelle: 'listeOperationDiverse.etat.valide', value: VALIDE },
];
export const EXPORT_EXCEL_OD = 'od';
